import constants from "../../core/constants";
class Controller {
  constructor(Events) {
    "ngInject";

    this.Events = Events;
    this.selectedItems = [];
    this.limitOptions = constants.tableLimitOptions;
  }

  $onInit() {
    this.page = this.page || constants.defaultPage;
    this.limit = this.limit || constants.defaultLimit;

    const toggleSortField = (field) => {
      if (field.sortBy === field.name) {
        field.sortBy = `-${field.name}`;
        field.sortIcon = "arrow_upward";
        field.sortTooltip = "DESC";
      } else {
        field.sortBy = field.name;
        field.sortIcon = "arrow_downward";
        field.sortTooltip = "ASC";
      }

      return field;
    };
    const setSortFields = (fields) => {
      fields.forEach((field) => {
        const isSelectedRegex = new RegExp(`${field.name}$`, "g");
        const isDesc = constants.descSortRegex;
        if (field.isSortable) {
          if (
            isSelectedRegex.test(this.selectedSort) &&
            isDesc.test(this.selectedSort)
          ) {
            field.sortBy = `-${field.name}`;
            field.sortIcon = "arrow_upward";
            field.sortTooltip = "DECS";
          } else {
            field.sortBy = field.name;
            field.sortIcon = "arrow_downward";
            field.sortTooltip = "ASC";
          }
        }
      });

      return fields;
    };
    this.fields = setSortFields(this.fields);
    this.onPaginate = (page, limit) =>
      this.Events.emit(this.paginateEvent, { page, limit });

    this.onSort = (field) => {
      if (field.isSortable) {
        this.selectedSort = toggleSortField(field).sortBy;
        this.fields = setSortFields(this.fields);
        this.Events.emit(this.sortEvent, { sort: field.sortBy });
      }
    };
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/listTable/listTable.controller.js